var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.73,5.38a13,13,0,0,1-.28,2.41,7.38,7.38,0,0,1-1.84,3.42,11.93,11.93,0,0,1-2,1.72.39.39,0,0,1-.51,0A12.17,12.17,0,0,1,4.68,10.8,7.18,7.18,0,0,1,3.19,7.74a12.17,12.17,0,0,1-.27-2.63V4.59a.42.42,0,0,1,.38-.47,9.54,9.54,0,0,0,2.06-.67,10.41,10.41,0,0,0,1.7-.93.44.44,0,0,1,.53,0A11.18,11.18,0,0,0,11,4l.44.1a.4.4,0,0,1,.32.4Zm-8-.49v.48A11.34,11.34,0,0,0,4,7.54a6.24,6.24,0,0,0,1.16,2.52,9.87,9.87,0,0,0,2.13,2,.11.11,0,0,0,.11,0,10.18,10.18,0,0,0,1.94-1.77,6.22,6.22,0,0,0,1.26-2.38A9.57,9.57,0,0,0,10.87,6c0-.36,0-.73,0-1.09l0,0-.15,0A11.92,11.92,0,0,1,7.42,3.4a.15.15,0,0,0-.2,0A11.46,11.46,0,0,1,4.8,4.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.07,8.09l.55-.56c.38-.39.77-.77,1.16-1.16a.26.26,0,0,1,.42,0l.21.21a.25.25,0,0,1,0,.38L7.26,9.11a.25.25,0,0,1-.38,0L5.65,7.91a.26.26,0,0,1,0-.37l.25-.25a.24.24,0,0,1,.37,0L7,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicSafety);
export default __webpack_public_path__ + "static/media/public_safety.f7ff6907c2821bf9aa4480feb60c355c.svg";
export { ForwardRef as ReactComponent };